import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {PaymentTypeResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

export const getOptionsFromPaymentTypes = (
  paymentTypes: PaymentTypeResponseBody[] | Nullish
): Option[] => {
  if (isNil(paymentTypes)) {
    return [];
  }

  return paymentTypes.map((paymentType) => ({
    label: paymentType.value,
    value: paymentType.key,
  }));
};
